module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node/browser.js
// module id = 784
// module chunks = 0